
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servico/[slug]",
      function () {
        return require("private-next-pages/servico/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servico/[slug]"])
      });
    }
  